var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.845,
    height: 27.766,
    viewBox: "0 0 25.845 27.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1353",
    "data-name": "Grupo 1353",
    transform: "translate(258 -170.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1352",
    "data-name": "Grupo 1352",
    transform: "translate(-258 178.756)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_143",
    "data-name": "L\\xEDnea 143",
    x2: 15.937,
    transform: "translate(0 5.626)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7019",
    "data-name": "Trazado 7019",
    d: "M-246,179.386l5.626,5.626L-246,190.639",
    transform: "translate(257.042 -179.386)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7020",
    "data-name": "Trazado 7020",
    d: "M-251,187.6v3.7a5.964,5.964,0,0,0,5.964,5.965h6.476A5.964,5.964,0,0,0-232.6,191.3V177.465a5.964,5.964,0,0,0-5.964-5.965h-6.476A5.964,5.964,0,0,0-251,177.465v3.7",
    transform: "translate(-0.559)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1699d49ee4c8395a5fb2100d77667ea2.svg";
export { ForwardRef as ReactComponent };